import { useState } from 'react';
import { DocumentType, useLazyWorkplacesQuery } from '../../../graphql/graphql';

export default function useWorkplaces() {
	const [getWorkplacesQuery, { data, isLoading }] = useLazyWorkplacesQuery();
	const [page, setPage] = useState(1);

	const getFlatWorkplaces = (filter: object) => {
		getWorkplacesQuery({
			...filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatWorkplaces,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
